// Helpers de período (YYYYMM) independentes do mock window.LEV.
export const MES_LABEL = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
export const MES_FULL  = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

export function monthOf(period) { return parseInt(String(period).slice(4, 6), 10); }
export function yearOf(period)  { return parseInt(String(period).slice(0, 4), 10); }

// "Mon/AA" (ex. "Jan/26") — rótulo curto de mês+ano, usado no dateline "N meses
// desde X" dos hovers/cards de indicador (ver Enquadramento, IndicatorValue.jsx/
// Painel2.jsx) — mês sozinho (MES_LABEL) não basta quando a janela cruza o
// ano-novo.
export function mesAnoLabel(period) { return `${MES_LABEL[monthOf(period) - 1]}/${String(yearOf(period)).slice(2)}`; }

// Soma (ou subtrai) meses a um período YYYYMM, devolvendo outro YYYYMM (número).
// `period` pode ser string ou número; `delta` pode ser negativo.
export function addMonths(period, delta) {
  const y = yearOf(period);
  const m = monthOf(period);
  const total = y * 12 + (m - 1) + delta;
  const ny = Math.floor(total / 12);
  const nm = (total % 12) + 1;
  return ny * 100 + nm;
}

// Período padrão ao entrar no portal: mês anterior ao mês/ano corrente.
export function defaultPeriod() {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
}

// Hoje em AAAA-MM-DD (fuso do navegador) — usado pelo filtro "Hoje" da aba Carteira,
// pra calcular os valores como estão agora em vez de no fechamento do mês.
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
